// extracted by mini-css-extract-plugin
module.exports = {"toggleFocusRing":"ToggleFocusRing_toggleFocusRing__LLW14"};